import { Redirect } from 'react-router-dom';
import * as paths from '../../routes/paths';
import Page from '../../components/Page';
import { calculateTrialDaysLeft } from '../LocationsPage/utils';
import { useSelector } from 'react-redux';
import {
  selectHomeTabPreference,
  selectUserProfile,
  selectUserIsFetching,
  selectUserRoles,
} from '../../selectors/user';
import { useCurrentUserRoles } from '../../hooks';
import Spinner from '@raydiant/raydial/components/Spinner';

const HomePage = () => {
  const homeTab = useSelector(selectHomeTabPreference);
  const isUserFetching = useSelector(selectUserIsFetching);
  const roles = useCurrentUserRoles();
  const currentUser = useSelector(selectUserProfile);
  const userRoles = useSelector(selectUserRoles);

  // Wait for user data to finish fetching
  // isUserFetching is shared by multiple actions (getProfile, getRolesAndPreferences)
  // so we also need to check if roles have been loaded (userRoles.length > 0)
  // to avoid redirecting before roles are available
  if (isUserFetching || !currentUser || userRoles.length === 0) {
    return (
      <Page>
        <div className="flex flex-1 justify-center items-center">
          <Spinner size="large" />
        </div>
      </Page>
    );
  }

  // if user is pro user within first 30 days of account creation, redirect to getting started page
  if (roles.isProUser && currentUser.createdAt) {
    const daysLeft = calculateTrialDaysLeft(currentUser.createdAt);

    if (daysLeft > 0) {
      return <Redirect to={paths.gettingStarted()} />;
    }
  }

  if (homeTab === 'library') {
    return <Redirect to={paths.library()} />;
  }

  if (homeTab === 'account') {
    return <Redirect to={paths.account()} />;
  }

  return <Redirect to={paths.screens()} />;
};

export default HomePage;
